import { motion } from 'framer-motion';
import { Droplets, Sun, Thermometer, Wind } from 'lucide-react';

const careTips = [
  {
    icon: Droplets,
    title: 'Water Properly',
    description: 'Check soil moisture before watering. Most plants prefer moist but not waterlogged soil.',
    color: 'text-blue-500',
    bgColor: 'bg-blue-50'
  },
  {
    icon: Sun,
    title: 'Provide Light',
    description: 'Place your plant in appropriate lighting conditions based on its specific needs.',
    color: 'text-amber-500',
    bgColor: 'bg-amber-50'
  },
  {
    icon: Thermometer,
    title: 'Control Temperature',
    description: 'Maintain consistent temperature between 65-80°F (18-27°C) for most indoor plants.',
    color: 'text-red-500',
    bgColor: 'bg-red-50'
  },
  {
    icon: Wind,
    title: 'Ensure Air Flow',
    description: 'Good air circulation helps prevent disease and promotes stronger growth.',
    color: 'text-emerald-500',
    bgColor: 'bg-emerald-50'
  }
];

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

export function PlantCareSection() {
  return (
    <section className="py-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-8"
      >
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Essential Plant Care Tips</h2>
        <p className="text-gray-600">Follow these basic guidelines to keep your plants healthy and thriving</p>
      </motion.div>

      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto px-4"
      >
        {careTips.map((tip, index) => (
          <motion.div
            key={index}
            variants={itemVariants}
            className={`${tip.bgColor} rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow`}
          >
            <div className="flex items-start gap-4">
              <div className={`${tip.color} p-3 rounded-full bg-white shadow-sm`}>
                <tip.icon className="w-6 h-6" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">{tip.title}</h3>
                <p className="text-gray-600 text-sm">{tip.description}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}